import React from 'react';
import { useParams } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import {APMPost} from "../components/APM/APMPost"

import APMInfra from "../components/APM/infra.json"
import APMDB from "../components/APM/db.json"
import APMApps from "../components/APM/apps.json"
import APMNetwork from "../components/APM/network.json"
import APMDevops from "../components/APM/devops.json"
import APMContainers from "../components/APM/containers.json"
import APMSLO from "../components/APM/slo.json"


function APMPage() {
  const { id } = useParams();
  const posts = {
    "infra": APMInfra,
    "db": APMDB,
    "apps": APMApps,
    "network": APMNetwork,
    "devops": APMDevops,
    "containers": APMContainers,
    "slo": APMSLO
  }
  
  if (!posts[id]) {
    return <NotFound />
  }

  return (
    <div className='w-full bg-white overflow-hidden'>
        <div className='container mx-auto px-4 py-8 '>
            <APMPost title={posts[id].title} sections={posts[id].sections}  />
      </div>
    </div>
  );
}

export default APMPage; 